/**
 * @file main.tsx
 * @path apps/website/src/main.tsx
 * @description React Entry point with centralized data fetching and routing.
 * Wraps app with HelmetProvider, QueryClientProvider, and TooltipProvider.
 * UPDATED: Added v7_startTransition future flag directly to RouterProvider to fix Suspense jumps.
 */

import { Toaster, TooltipProvider } from "@sirbastians/ui";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";

// App component now purely handles the global Splash Screen
import App from "./App";

// Initialize QueryClient
const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={0}>
          <App />
          <Toaster position="top-right" richColors />
        </TooltipProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </StrictMode>,
);
